
var freqMap = {
  "1-month" : "10%",
  "3-month" : "20%",
  "6-month" : "26%",
}

function getDiscountFromPlan(plan){

  if (!plan) return null

  /*
    4-Level Discount Resolution Fallback:
    ------------------------------------
    1. Regex Match:      Extracts discount % from selling_plan_name (e.g., "Save 15%").
    2. Dynamic Calc:     Calculates actual % difference between subscribePrice & onetimePrice.
    3. Frequency Lookup: Maps delivery frequency (pv_freq_value e.g., "3-month") via freqMap.
    4. Hardcoded Default: Falls back to a baseline "10%" if all prior options fail.
  */
  const match = plan.selling_plan_name?.match(/\d+(?:\.\d+)?%/);
  const discountFromPrice = (plan.subscribePrice > 0 && plan.onetimePrice > 0 )
      ? Math.floor((1 - plan.subscribePrice / plan.onetimePrice) * 100) + "%"
      : null;

  const discountNormalized = match?.[0]
      ?? discountFromPrice
      ?? freqMap[plan.pv_freq_value]
      ?? "10%";


  if (!match?.[0]) {
    console.warn("No selling_plan_name discount % found:", plan?.selling_plan_name);
  }

  return  discountNormalized
}

function callJqueryModal(id, fadeDuration) {
  $(id).modal({ fadeDuration });
}

var getCookie = function (name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
};

function scrollToProductsBlock(e) {
  e.preventDefault();
  const productBlock = $("#home-main-tabs");
  const cartObject = $(".js-ajax-cart-drawer");
  if (cartObject && cartObject.hasClass("is-open")) {
    $(".js-ajax-cart-drawer-close").click();
  }
  console.log(typeof redirectOnCall);
  if (productBlock.length) {
    productBlock.find('[data-target="products"]').trigger("click");
    $("html, body").animate(
      {
        scrollTop: productBlock.offset().top - $("header").outerHeight(),
      },
      500
    );
  } else if (typeof redirectOnCall === "function") {
    // shopify app has access to theme js
    redirectOnCall("#shopify-section-home-main-tabs");
  } else {
    // recharge app has no access to theme js
    var cookieValue = getCookie("pro_doctor");
    if (cookieValue) {
      window.location =  "/pages/" + cookieValue;
    }
  }
}

function fillInPriceDataForProduct(container_selector, product) {
  const container = $(container_selector);
  const originalData = product.variant_to_price;
  const subscriptionData = product.duplicate_to_price;
  const originalPrice = originalData[Object.keys(originalData)[0]];
  const subscriptionPrice = subscriptionData[Object.keys(subscriptionData)[0]];
  let perBottleDiscount = subscriptionPrice / product.package_size;
  perBottleDiscount = Math.round(perBottleDiscount / 100) * 100;
  let perBottle = originalPrice / product.package_size;
  perBottle = Math.round(perBottle / 100) * 100;
  // removed price per bottle 05/25/21, since we using packs and systems
  // container.find('.rc_label__single_item_price').text(`${theme.Currency.formatMoney(perBottleDiscount, theme.moneyFormat)}/bottle`);
  // container.find('.rc_label__single_item_price-no_discount').text(`${theme.Currency.formatMoney(perBottle, theme.moneyFormat)}/bottle`);
  container.find(".rc_label__single_item_price").text(``);
  container.find(".rc_label__single_item_price-no_discount").text(``);
  container
    .find(".rc_label__original_price")
    .text(theme.Currency?.formatMoney(originalPrice, theme.moneyFormat));
  container
    .find(".rc_price__onetime")
    .text(theme.Currency?.formatMoney(originalPrice, theme.moneyFormat));
  container
    .find(".rc_price__autodeliver")
    .text(theme.Currency?.formatMoney(subscriptionPrice, theme.moneyFormat));
  container
    .find(".rc_label__discount")
    .text(
      `Save ${theme.Currency?.formatMoney(
        originalPrice - subscriptionPrice,
        theme.moneyFormat
      )}`
    );
}

$(document).ready(function () {
  // Only 1-month cadence is sold as a one-time purchase: hide the pack-size
  // ("Purchase Type") selector and force it to the 1-month variant whenever
  // One-Time Purchase is selected, in both the quick-add modal and the PDP's
  // ReCharge purchase-option widget.
  function toggleModalPurchaseType($radio) {
    var $modal = $radio.closest(".home-products-modal-container");
    if (!$modal.length) return;
    var isOneTime = ($radio.attr("id") || "").indexOf("purchase_type_one_") === 0;
    var $select = $modal.find('select[id^="ProductSelect-"]');
    if (!$select.length) return;
    var $label = $modal.find('label[for="' + $select.attr("id") + '"]');
    if (isOneTime) {
      $label.hide();
      $select.hide();
      if ($select.find("option").length) {
        $select.val($select.find("option").first().val());
        $select.trigger("change");
      }
    } else {
      $label.show();
      $select.show();
    }
  }

  function togglePdpPurchaseType($radio) {
    var isOneTime = $radio.hasClass("rc_widget__option__input--onetime");
    var $wrapper = $(".selector-wrapper.product-form__item").first();
    if (!$wrapper.length) return;
    if (isOneTime) {
      $wrapper.hide();
      var $select = $wrapper.find("select.single-option-selector");
      if ($select.find("option").length) {
        $select.prop("selectedIndex", 0);
        $select.trigger("change");
      }
    } else {
      $wrapper.show();
    }
  }

  $(document).on(
    "change",
    'input[id^="purchase_type_sub_"], input[id^="purchase_type_one_"]',
    function () {
      toggleModalPurchaseType($(this));
    }
  );

  $(document).on("change", ".rc_widget__option__input", function () {
    togglePdpPurchaseType($(this));
  });

  function applyInitialPurchaseTypeState() {
    $(
      'input[id^="purchase_type_sub_"]:checked, input[id^="purchase_type_one_"]:checked'
    ).each(function () {
      toggleModalPurchaseType($(this));
    });
    $(".rc_widget__option__input:checked").each(function () {
      togglePdpPurchaseType($(this));
    });
  }
  applyInitialPurchaseTypeState();

  // The ReCharge widget inserts its own container as the FIRST child of the
  // product form, which pushes our "Select a delivery option" label below
  // it. Move the label back above the widget so it reads as a heading for
  // the whole delivery-option area, not as text sandwiched between the
  // radios and the pack-size dropdown.
  function repositionSelectLabel() {
    $("p.select-label").each(function () {
      var $label = $(this);
      var $form = $label.closest("form");
      if ($form.length && !$form.children().first().is($label)) {
        $form.prepend($label);
      }
    });
  }

  // The ReCharge widget mounts asynchronously after page load, so its radios
  // may not exist yet on the first pass above; keep checking briefly.
  var rcCheckAttempts = 0;
  var rcCheckInterval = setInterval(function () {
    rcCheckAttempts++;
    if ($(".rc_widget__option__input").length || rcCheckAttempts > 20) {
      applyInitialPurchaseTypeState();
      repositionSelectLabel();
      clearInterval(rcCheckInterval);
    }
  }, 250);
});
